import React, { useState, useEffect } from 'react';
import * as Types from '../../services/api/api.types';
import RotatingProductDisplay from './RotatingProductDisplay';
import { config } from '../../config/env';
import logger from '../../utils/logger';

const NewProducts: React.FC = () => {
    const [products, setProducts] = useState<Types.ProductFull[]>([]);
    const [loading, setLoading] = useState(true);
    const [settings, setSettings] = useState<{
        rotationInterval?: number;
        autoRotate?: boolean;
    }>({});

    useEffect(() => {
        const fetchNewProducts = async () => {
            try {
                setLoading(true);

                const [settingsResponse, productsResponse] = await Promise.all([
                    fetch(`${config.apiUrl}/settings/homepage`, {
                        credentials: 'include'
                    }),
                    fetch(`${config.apiUrl}/settings/homepage/products`, {
                        credentials: 'include'
                    })
                ]);

                if (settingsResponse.ok) {
                    const settingsData = await settingsResponse.json();
                    setSettings({
                        rotationInterval: settingsData.rotationInterval || 5000,
                        autoRotate: settingsData.autoRotate !== false,
                    });
                }

                if (productsResponse.ok) {
                    const data = await productsResponse.json();
                    setProducts(data.newProducts ?? []);
                }
            } catch (error) {
                logger.error('Failed to load homepage products:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchNewProducts();
    }, []);

    return (
        <RotatingProductDisplay
            products={products}
            rotationInterval={settings.rotationInterval}
            autoRotate={settings.autoRotate}
            title="Нови продукти"
            loading={loading}
        />
    );
};

export default NewProducts;